const ACTION_GET_CONTRACT_DETAIL = 'ACTION_GET_CONTRACT_DETAIL'
const ACTION_GET_CONTRACT_DETAIL_SUCCESS = 'ACTION_GET_CONTRACT_DETAIL_SUCCESS'
const ACTION_GET_CONTRACT_DETAIL_RESET = 'ACTION_GET_CONTRACT_DETAIL_RESET'
const ACTION_GET_CONTRACT_NUMBER_SUCCESS = 'ACTION_GET_CONTRACT_NUMBER_SUCCESS'

export {
  ACTION_GET_CONTRACT_DETAIL,
  ACTION_GET_CONTRACT_DETAIL_SUCCESS,
  ACTION_GET_CONTRACT_DETAIL_RESET,
  ACTION_GET_CONTRACT_NUMBER_SUCCESS,
}
